import { type DashboardReady } from "./useDashboardController";
import { NAV_VIEWS, NAV_LINKS, nav, MOBILE_LISTING_VIEWS } from "./model";
import { Link } from "wouter";
import { ProfileCard } from "../../components/DashboardProfile";
import { Home, UserCircle, ClipboardCheck, Wallet, Settings } from "lucide-react";
import { LogoutButton } from "../../components/LogoutButton";
import { MobileAccountBreadcrumb } from "../../components/MobileAccountBreadcrumb";

export function DashboardAccountNavigation(props: DashboardReady) {
  const { accountNav, view, navLabel, profile, activeResume, loadProfile, t, doLogout, accountSection } = props;


  const workspaceNavigation = accountNav.filter(([label]) => !["Contracts", "Wallet / Escrow", "Settings"].includes(label)).map(([label, Icon]) => {
            const viewKey = NAV_VIEWS[label];
            const href = NAV_LINKS[label] || (viewKey ? `/dashboard?view=${viewKey}` : "/dashboard");
            const active = viewKey === view && !!view;
            return (
              <Link key={label} href={href}
                aria-current={active ? "page" : undefined}
                className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium ${active ? "bg-navy text-white" : "text-mut hover:bg-navy-50 hover:text-navy"}`}>
                <Icon className="w-4 h-4" /><span className="flex-1 text-left">{navLabel(label)}</span>
              </Link>
            );
          });
  return (<><aside className="dashboard-account-sidebar self-start h-fit hidden lg:block space-y-2 desktop-sidebar-scroll" aria-label="Account navigation">
        <ProfileCard profile={profile} activeResume={activeResume} onResumeChanged={loadProfile} compact />
        <div className="card p-2 dashboard-sidebar-nav">
          <nav className="dashboard-primary-nav" aria-label={t("dashboard.mainNavigation", "Dashboard navigation")}>
            <Link href="/dashboard" aria-current={!view ? "page" : undefined}><Home size={17} />{t("dashboard.title", "Dashboard")}</Link>
            <Link href="/worker-profile"><UserCircle size={17} />{t("dashboard.myProfile", "My profile")}</Link>
            <Link href="/contracts"><ClipboardCheck size={17} />{t("dashboard.nav.contracts")}</Link>
            <Link href="/wallet"><Wallet size={17} />{t("dashboard.nav.wallet")}</Link>
            <Link href="/settings"><Settings size={17} />{t("dashboard.nav.settings")}</Link>
          </nav>
          <nav className="dashboard-secondary-nav" aria-label={t("dashboard.accountSections", "Account sections")}>
            {workspaceNavigation}
          </nav>
          <LogoutButton onLogout={doLogout} variant="ghost" className="mt-1 min-h-11 w-full justify-start rounded-lg px-3 py-2.5 text-sm font-medium text-brand-red hover:bg-brand-red/5">
            {t("dashboard.nav.logout")}
          </LogoutButton>
        </div>
      </aside>

      {view && accountSection && !MOBILE_LISTING_VIEWS.includes(view) && view !== "hiring" && <MobileAccountBreadcrumb currentLabel={navLabel(accountSection[0])} />}

      {/* Tablet account navigation; mobile features return through their breadcrumb. */}
      <nav className="hidden sm:block lg:hidden -mx-4 px-4 overflow-x-auto no-scrollbar dashboard-account-rail" aria-label="Account sections">
        <div className="flex gap-2 w-max pb-2">
          {accountNav.map(([label, Icon]) => {
            const viewKey = NAV_VIEWS[label];
            const href = NAV_LINKS[label] || (viewKey ? `/dashboard?view=${viewKey}` : "/dashboard");
            const active = viewKey === view && !!view;
            return (
              <Link key={label} href={href}
                className={`shrink-0 whitespace-nowrap inline-flex items-center gap-1.5 px-3 py-2 rounded-full text-xs font-semibold border ${active ? "bg-navy text-white border-navy" : "bg-white text-navy border-line"}`}>
                <Icon className="w-3.5 h-3.5" />{navLabel(label)}
              </Link>
            );
          })}
        </div>
      </nav></>);
}
